import styled, { css } from 'styled-components/macro'

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  fonts: { brandonGrotesqueMedium },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletPortraitUp },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  typography: { buttonText },
} = mixins;

export const FooterContainer = styled.footer`
  padding: 5rem 1rem 1rem 1rem;
  background-color: ${color(`black`)};
`;

export const SocialIconListItem = styled.li`
  margin-left: ${spacingsize(10)};

  &:first-child {
    margin-left: 0;
  }
`;

export const SocialIcon = styled.img`
  height: 5rem;

  &:hover {
    filter: drop-shadow(0 0 0.75rem #fff);
  }
`;

export const CopyrightContainer = styled.div`
  width: 100%;
  text-align: center;
  color: ${color(`white`)};
`;